import { Model } from '@vuex-orm/core';
import { Call } from './Call';

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class CallAlert extends Model {
    static entity = 'callAlerts'

    static primaryKey = 'id'

    static fields () {
      return {
        id: this.attr(null),
        created_at: this.attr(null),
        call_id: this.attr(null),
        category_id: this.attr(null),
        text: this.string(null),
        updated_at: this.attr(null),

        call: this.belongsTo(Call, 'call_id'),
        category: this.belongsTo(CallAlertCategory, 'category_id')
      };
    }

    /**
     * Get id for an alert that is not yet persisted.
     */
    get new_id () {
      return `new_${this.call_id}`;
    }

    /**
     * Check if this alert is using a temporary id
     */
    get has_new_id () {
      return this.id === this.new_id;
    }

    get has_no_text () {
      return !this.text || !this.text.length;
    }

    get missing_category () {
      return !this.category_id && this.text;
    }

    async updateText (newValue) {
      await this.$update({ where: (record) => { return record.call_id === this.call_id; }, data: { text: newValue }});
      return this;
    }

    async persist () {
      if (this.has_no_text) {
        if (!this.has_new_id) {
          await CallAlert.$delete({ params: { id: this.id }});
        } else {
          // Don't save it
        }
      } else if (this.has_new_id) {
        await CallAlert.$create({ data: { call_id: this.call_id, text: this.text, category_id: this.category_id }});
        await CallAlert.delete({ where: this.new_id });
      } else {
        await CallAlert.$update({ params: { id: this.id }, data: { text: this.text, category_id: this.category_id }});
      }
      return this;
    }

    /**
     * Axios default overrides
     * @see {@link https://github.com/vuex-orm/plugin-axios/blob/master/README.md}
     */
    static methodConf = {
      http: {
        url: 'regicall/callAlerts'
      },
      methods: {
        $update: {
          name: 'update',
          http: {
            url: '/:id',
            method: 'patch'
          }
        }
      }
    }
}

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class CallAlertCategory extends Model {
  static entity = 'callAlertCategories'

  static primaryKey = ['id']

  static fields () {
    return {
      id: this.attr(null),
      status: this.attr(null),
      name: this.attr(null),
      description: this.attr(null)
    };
  }

  /**
   * Axios default overrides
   * @see {@link https://github.com/vuex-orm/plugin-axios/blob/master/README.md}
   */
  static methodConf = {
    http: {
      url: 'regicall/callAlertCategories'
    }
  }
}
